export function extractDay(dateString: string): string {
  return dateString.match(/^\d+/)?.[0] ?? '';
}
